import { Component, inject } from '@angular/core';

import { LayoutService } from '@components/layout/layout.service';
import { RouterDataService } from '@services/router-data.service';
import { StudentNavigationService } from '@services/navigation/student-navigation.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-link-prev-next',
  templateUrl: './link-prev-next.component.html',
  styleUrls: ['./link-prev-next.component.scss'],
  standalone: false,
})
export class LinkPrevNextComponent {
  layoutService = inject(LayoutService);
  routerDataService = inject(RouterDataService);
  studentNavigationService = inject(StudentNavigationService);
  private router = inject(Router);

  onClickNavigate(position: 'list' | 'prev' | 'next') {
    if (this.studentNavigationService.isLoading) {
      return;
    }
    this.router.navigateByUrl(this.studentNavigationService[position].url, { replaceUrl: position !== 'list' });
  }
}
